











































































import Vue, { PropType } from 'vue'
import { ChatbotSchemaEntry, ChatbotStyles } from '@/types/Chatbot.interface'
import Input, { ColorMode, InputType } from '@/types/Input.interface'
import FormStyleImage from '@/components/FormStyleImage.vue'
import { objectSet } from '@/utility/helpers'
export default Vue.extend({
    components: { FormStyleImage },
    props: {
        chatbotStyles: {
            type: Object as PropType<ChatbotStyles>,
            required: true
        },
        chatbotSchema: {
            type: Array as PropType<ChatbotSchemaEntry[]>,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            panelHeaderColor: '#FAFAFA'
        }
    },
    computed: {
        calloutMessageInput(): Input[] {
            return [
                {
                    type: InputType.TEXTAREA,
                    name: 'Callout',
                    label: 'Callout Message',
                    path: 'agent.message',
                    rows: '3',
                    validate: 'max:45',
                    disabled: this.loading
                }
            ]
        },
        colorInputs(): Input[] {
            return [
                {
                    type: InputType.COLORBTN,
                    name: 'Primary Color',
                    label: 'Primary',
                    path: 'colors.primary',
                    colClass: `d-flex justify-start`,
                    class: 'right',
                    mode: ColorMode.hexa,
                    disabled: this.loading
                },
                {
                    type: InputType.COLORBTN,
                    name: 'Background Color',
                    label: 'Background',
                    path: 'colors.background',
                    colClass: `d-flex justify-start`,
                    class: 'right',
                    mode: ColorMode.hexa,
                    disabled: this.loading
                }
            ]
        },
        complianceSubmitInputs(): Input[] {
            return [
                {
                    type: InputType.TEXTAREA,
                    name: 'Compliance Message',
                    label: 'Compliance Message',
                    path: 'content.complianceMessage',
                    rows: 3,
                    colClass: 'd-flex justify-start',
                    validate: 'required|max:300',
                    disabled: this.loading
                },
                {
                    type: InputType.TEXT,
                    name: 'Privacy Policy',
                    label: 'Privacy Policy',
                    path: 'content.privacyPolicyLink',
                    rows: 2,
                    colClass: 'd-flex justify-start',
                    validate: 'url',
                    disabled: this.loading
                },
                {
                    type: InputType.TEXT,
                    name: 'Terms of Service',
                    label: 'Terms of Service',
                    path: 'content.termsOfServiceLink',
                    rows: 2,
                    colClass: 'd-flex justify-start',
                    validate: 'url',
                    disabled: this.loading
                },
                {
                    type: InputType.TEXT,
                    name: 'Submit Button Text',
                    label: 'Submit Button Text',
                    path: 'content.submitMessage',
                    validate: 'required|max:50',
                    disabled: this.loading
                }
            ]
        },
        openedStateInputs(): Input[] {
            return [
                {
                    type: InputType.TEXT,
                    name: 'Title',
                    label: 'Header Title',
                    path: 'header.title',
                    cols: 12,
                    validate: 'max:100',
                    disabled: this.loading
                },
                {
                    type: InputType.TEXT,
                    name: 'Subtitle',
                    label: 'Header Subtitle',
                    path: 'header.subtitle',
                    cols: 12,
                    validate: 'max:100',
                    disabled: this.loading
                }
            ]
        },
        submitInput(): Input[] {
            return [
                {
                    type: InputType.TEXT,
                    name: 'Submit Button Text',
                    label: 'Submit Button Text',
                    path: 'content.submitMessage',
                    validate: 'max:50',
                    disabled: this.loading
                }
            ]
        },
        welcomeMessageInput(): Input[] {
            return [
                {
                    type: InputType.TEXTAREA,
                    name: 'Welcome Message',
                    label: 'Welcome Message',
                    path: 'content',
                    rows: 3,
                    colClass: `d-flex justify-start`,
                    validate: 'max:300',
                    disabled: this.loading
                }
            ]
        },
        successMessageInput(): Input[] {
            return [
                {
                    type: InputType.TEXTAREA,
                    name: 'Success',
                    label: 'Success Message',
                    path: 'content.successMessage',
                    rows: '3',
                    validate: 'max:300',
                    disabled: this.loading
                }
            ]
        }
    },
    methods: {
        setAgentImage(link: string): void {
            //  Set our chatbot agent image
            this.chatbotStyles.agent.image = link

            //  Tell the parent to update
            this.$emit('submit', this.chatbotStyles)
        },
        async submitSchema(): Promise<void> {
            //  Grab our appform ref
            const appForm = this.$refs['chatbot-schema-submission-button']

            //  Validate our input
            const valid = await appForm.$validator.validate()

            //  If invalid, do nothing
            if (!valid) return

            //  Else, we're valid so go ahead and submit
            this.$emit('submitSchema', this.chatbotSchema)
        },
        removeImage(): void {
            //  Unset our agent image
            this.chatbotStyles.agent.image = null

            //  Tell the parent to update
            this.$emit('submit', this.chatbotStyles)
        },
        updateModel(input: Input, val): void {
            //  Set our value
            objectSet(input.path, val, this.chatbotStyles)

            //  Check if we want to submit
            const submit = input.type !== 'COLORBTN' && input.type !== 'TEXT'

            //  If we want to submit, then do it
            if (submit) this.$emit('submit', this.chatbotStyles)
        },
        async updateSchema(input: Input, val): Promise<void> {
            //  set our value
            objectSet(input.path, val, this.chatbotSchema[1])
        },
        updateWelcomeMessage(_, val: string): void {
            //  Update the welcome message
            this.chatbotSchema[0].content = val
        },
        updateSuccessMessage(_, val: string): void {
            //  Update the success message
            this.chatbotSchema[1].content.successMessage = val
        }
    },
    watch: {
        chatbotStyles: {
            deep: true,
            handler() {
                //  Update all of our app forms
                for (const ref in this.$refs) {
                    //  Check if this ref contains "style"
                    const valid = ref.includes('style')

                    //  If it is invalid, do nothing
                    if (!valid) continue

                    //  Update temp
                    this.$refs[ref].temp = window._.cloneDeep(this.chatbotStyles)
                }
            }
        },
        chatbotSchema: {
            deep: true,
            handler() {
                //  Update all of our app forms
                for (const ref in this.$refs) {
                    //  Check if this ref contains "schema"
                    const valid = ref.includes('schema')

                    //  If it is invalid, do nothing
                    if (!valid) continue

                    //  Our clone depends on if this is for welcome or submission
                    const model = ref.includes('submission')
                        ? this.chatbotSchema[1]
                        : this.chatbotSchema[0]

                    //  Update temp
                    this.$refs[ref].temp = window._.cloneDeep(model)
                }
            }
        }
    }
})
